<template>
    <el-container id="tab">
        <el-aside :width="isCollapse ? '20px' : '240px'">
            <el-card v-show="!isCollapse" class="box-card" shadow="never">
                <div slot="header">
                    <span>商品类别</span>
                    <el-button style="float: right; padding: 3px 0;" icon="el-icon-d-arrow-left" type="text" @click="showCollapse"></el-button>
                </div>
                <order-cascader ref="orderCascader" :product-params="{customerID: queryitem.customerID}" :billType="'DHD'" @get-product-data="getProductData">
                    <template v-slot="{ row, node }">
                        <span v-if="row.text.length < 7 && (row.type == 'PP' || !node.isLeaf || row.type == '')" class="cascader_text">{{ row.text }}</span>
                        <el-popover v-else :ref="row.value" popper-class="cascader_popper" trigger="hover" placement="right">
                            <span v-if="row.type == 'PP'">{{ row.text }}</span>
                            <div v-else style="width: auto; min-height: 100px; max-height: 400px;" v-loading="!row.isHasPromotionData">
                                <div v-if="row.isHasPromotionData">
                                    <div>
                                        <el-row :gutter="20">
                                            <el-col :span="6">
                                                <label>促销方案:</label><span>{{row.planInfo.planDesc}}</span>
                                            </el-col>
                                            <el-col :span="6">
                                                <label>开始日期:</label><span>{{row.planInfo.beginDate}}</span>
                                            </el-col>
                                            <el-col :span="6">
                                                <label>结束日期:</label><span>{{row.planInfo.endDate}}</span>
                                            </el-col>
                                            <el-col :span="6">
                                                <label>起始数量:</label><span>{{row.planInfo.segments}}</span>
                                            </el-col>
                                        </el-row>
                                    </div>
                                    <div class="cascader_table">
                                        <el-table :data="row.itemList" border height="100%" max-height="100%" style="width: 100%">
                                            <el-table-column type="index"></el-table-column>
                                            <el-table-column prop="itemName" label="商品" width="180"></el-table-column>
                                            <el-table-column prop="productionDate" label="生产日期" width="100"></el-table-column>
                                            <el-table-column prop="isLargessFormat" label="是否赠品" width="80"></el-table-column>
                                            <el-table-column label="单位名称" width="90">
                                                <template slot-scope="scope">
                                                    <span v-show="scope.row.salUnitName">{{scope.row.salUnitName}}</span>
                                                    <span v-show="scope.row.midUnitName">{{scope.row.midUnitName}}</span>
                                                    <span v-show="scope.row.salUnitConversion != 1 && scope.row.invUnitName">{{scope.row.invUnitName}}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="促销价格">
                                                <template slot-scope="scope">
                                                    <span v-show="scope.row.salUnitName">{{scope.row.salUnitPrice}}</span>
                                                    <span v-show="scope.row.midUnitName">{{scope.row.midUnitPrice}}</span>
                                                    <span v-show="scope.row.salUnitConversion != 1 && scope.row.invUnitName">{{scope.row.invUnitPrice}}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="赠品数量">
                                                <template slot-scope="scope">
                                                    <span v-show="scope.row.salUnitName">{{scope.row.salUnitQty}}</span>
                                                    <span v-show="scope.row.midUnitName">{{scope.row.midUnitQty}}</span>
                                                    <span v-show="scope.row.salUnitConversion != 1 && scope.row.invUnitName">{{scope.row.invUnitQty}}</span>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                        <el-row :gutter="20" style="margin-bottom: 0; margin-top: 10px;">
                                            <el-col :span="12">
                                                <span>倍数:</span>
                                                <el-input-number v-model="row.multiple" controls-position="right" :min="1" :step="1" step-strictly size="small" @change="promotionInputChange($event, row)"></el-input-number>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-button type="primary" size="small" @click="addProductToOrder(row, true)">添加全部商品到单据</el-button>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </div>
                            </div>
                            <span slot="reference" class="cascader_text" @mouseenter="row.type == 'CX' ? getPromotion(row) : () => {}">{{ row.text }}</span>
                        </el-popover>
                    </template>
                </order-cascader>
            </el-card>
            <div class="isCollapse" v-show="isCollapse" @click="showCollapse">
                <span style="text-align: center;">商品</span>
                <el-button icon="el-icon-d-arrow-right" type="text"></el-button>
                <span style="text-align: center;">类别</span>
            </div>
        </el-aside>
        <el-main>
            <el-tabs type="border-card" v-model="tabsName" class="tabs-card">
                <el-card shadow="never" class="form-box">
                    <div class="form-box-left">
                        <el-form :inline="true" class="query_form" ref="queryInfo" :model="queryForm" label-position="right">
                            <el-form-item label="客户" prop="customer.selected">
                                <select-multiple ref="customer" :change="() => { querySelect('customer', 'salOrderMeet')}" class="query_form_item" :select-data="queryForm.customer" :isClear="false" is-table isTable :column-list="selectMultipleTableColumnListCommon.customer" @keydown.enter.right.native="querySelect('customer', 'salOrderMeet')"></select-multiple>
                            </el-form-item>
                            <el-form-item label="订货会" prop="salOrderMeet.selected">
                                <select-multiple ref="salOrderMeet" :change="() => { querySelect('salOrderMeet', 'salesman') }" class="query_form_item" :select-data="queryForm.salOrderMeet" :isClear="false" @keydown.enter.right.native="querySelect('salOrderMeet', 'salesman')" @keydown.left.native="queryFormLeftOrRight($refs.salOrderMeet, $refs.customer)"></select-multiple>
                            </el-form-item>
                            <el-form-item label="业务员" prop="salesman.selected">
                                <select-multiple ref="salesman" :change="() => { querySelect('salesman', 'remark') }" class="query_form_item" :select-data="queryForm.salesman" :isClear="false" is-scroll @keydown.enter.right.native="querySelect('salesman', 'remark')" @keydown.left.native="queryFormLeftOrRight($refs.salesman, $refs.salOrderMeet)"></select-multiple>
                            </el-form-item>
                            <!-- <el-form-item label="品牌" prop="brand.selected">
                                <select-multiple ref="brand" :change="() => { querySelect('remark') }" class="query_form_item" :select-data="queryForm.brand" :isClear="false"></select-multiple>
                            </el-form-item> -->
                            <el-form-item label="备注" prop="remark.selected">
                                <el-input ref="remark" class="query_form_item" v-model.trim="queryForm.remark.selected" :placeholder="queryForm.remark.placeholder" clearable @keydown.enter.right.native="$refs['queryFormRef'].getProductData()" @keydown.left.native="queryFormLeftOrRight($refs.remark, $refs.salesman)"></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </el-card>
                <el-tab-pane label="订货单" name="A">
                    <!-- <order-table :tag="item.value" :args="queryForm" :ref="'orderTable'+item.value" @billDetailOpen="billDetailOpen"></order-table> -->
                    <order-table ref="queryFormRef" :from="queryitem" :showBtn="true" class="query" :power="power" :btn-power="btnPower" @show-dialog="showDialog" @hide-dialog="hideDialog"></order-table>
                </el-tab-pane>
            </el-tabs>
        </el-main>
        <sal-order-account-dialog ref="accountDialog" :visible.sync="dialogVisible" :customerPayType="customerPayType" :power="power" :dialog-info="dialogInfo" @submit="onSubmit($event)"></sal-order-account-dialog>
    </el-container>
</template>
<script>
import cascaderPanel from '@/components/common/cascaderPanel.vue'
import orderTable from '@/components/saleManage/salOrderMeet/orderEntering.vue'
import orderCascader from '@/components/saleManage/salOrderMeet/orderCascader.vue'
import salOrderAccountDialog from '@/components/saleManage/salOrderMeet/salOrderAccountDialog.vue'
import { toRawType, getResultArray, toFixedRe } from '@/assets/js/common.js'
import { queryFormLeftOrRight } from '@/assets/js/orderEntering.js'
export default {
    components: {
        cascaderPanel,
        orderTable,
        orderCascader,
        salOrderAccountDialog
    },
    props: ['billNo', 'tag'],
    name: 'SalOrderItemOrder',
    mixins: [selectMultipleTableColumnListCommonMixins],
    data() {
        return {
            queryForm: {
                customer: { submitName: 'customer', selected: {}, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择客户', request: { url: '/Account/customerDefine/getCustomerListForVue.html', type: 'post', params: { page: 1, size: 10 }, text: '', value: '' } },
                salOrderMeet: { submitName: 'salOrderMeet', selected: {}, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择订货会', request: { url: '/Account/dataSearchVue/selectOrderMeetForVue.html', type: 'post', params: { page: 1, size: 10, meetType: 'A', orderMeetType: 'A',endDate: new Date().toISOString().slice(0, 10) }, text: '', value: '' } },
                salesman: { submitName: 'salesman', selected: {}, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择业务员', request: { url: '/Account/userDefine/selectUserListForVue.html', type: 'post', params: { page: 1, size: 10 }, text: '', value: '' } },
                remark: { submitName: 'remark', selected: '' },
                // brand: { submitName: 'brand', selected: {}, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择品牌', request: { url: 'Account/dataSearch/selectFinanceBrandListForVue.html', type: 'post', params: { page: 1, size: 5, isEnabled: 'Y' }, text: '', value: '' } },
            },
            beforeTableData: [],
            dialogTableVisible: false,
            dialogTableLoading: false,
            dialogTableData: [],
            dialogTableSum: {},
            tableData: [],
            tabsName: 'A',
            selection: {
                length: 0,
                amt: 0,
                adjustAmt: 0,
                prePayAmt: 0
            },
            isCollapse: false,
            itemParams: {
                firstValue: '',
                secondValue: ''
            },
            isGetPower: false,
            btnPower: {},
            power: {
                isStrikePerOrder: '', // 是否按单清欠 Y/N
                isSecondBatch: '', // 是否启用小老板模式 Y/N
                isDisabledBillDate: '', // 是否禁用单据日期 Y/N
                splitPayAndReturnPrePay: '', // 退货预收和欠款预收是否分开 Y/N
                brandArrear: '', // 是否分品牌欠款和预收款 Y/N
                isShowProductionDate: '', // 是否显示显示生产日期 Y/N
                isShowFlavor: '', // 是否显示多口味 Y/N
                isShowItemCode: '', // 是否显示商品编号 Y/N
                isShowInvBarCode: '', // 是否显示小单位条码 Y/N
                allowCostPrice: '', // 是否允许查看成本价 Y/N
                allowRecord: '', // 是否直接记账，N 保存草稿，Y直接记账
                payType: '', // 收款方式 混合收款(A)、优先现金(B)、优先预收(C)、优先欠款(D)
                isDefaultCollectionMethod: '', // 默认支付方式
                isMoreCollection: '', // 是否允许混合收款，默认为N(不允许)
                isEnableProductDate: '' // 是否可以修改生产日期 Y/N
            },
            dialogVisible: false,
            dialogInfo: {
                payType: {},
                splitPayAndReturnPrePay: '1', // 预收方式
                account: { submitName: 'account', selected: {}, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: false, isRemote: false, isPagination: false, isReSearch: false, isDisabled: false, isClear: false, list: [], placeholder: '', request: { url: '/Account/dataSearchVue/selectAccountType.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                discountAmt: 0, // 折扣金额
                cashAmt: 0, // 现金
                prePayAmt: 0, // 预收款
                arrearAmt: 0, // 欠款
                cardAmt: 0, // 刷卡
                payableAmt: 0, // 实收金额
                totalAmt: 0
            },
            customerPayType: ''
        }
    },
    computed: {
        queryitem() {
            let tempItem = {}
            Object.values(this.queryForm).forEach(item => {
                if (toRawType(item.selected) == 'Array') {
                    if (item.submitName == 'billDate') {
                        tempItem['beginDate'] = item.selected[0] || ''
                        tempItem['endDate'] = item.selected[1] || ''
                        return false
                    }
                    tempItem[item.submitName] = item.selected.map(i => "'" + i.value + "'").join(',') || ''
                } else if (toRawType(item.selected) == 'Object') {
                    if (['salOrderMeet', 'customer', 'salesman'].includes(item.submitName)) {
                        tempItem[item.submitName + 'ID'] = item.selected.value || ''
                        tempItem[item.submitName + 'Name'] = item.selected.text || ''
                        return false
                    }
                    tempItem[item.submitName] = item.selected.value || ''
                } else {
                    tempItem[item.submitName] = item.selected || ''
                }
            })
            return tempItem
        },
    },
    created() {
        this.getPower()
        this.getBtnPower()
        console.log(this.billNo, this.tag)
        if (this.billNo) {
            this.getEditTabledata()
        }
    },
    mounted() {
        $(this.$refs.customer.$el).find('input').click(this.selectClick)
        $(this.$refs.salOrderMeet.$el).find('input').click(this.selectClick)
        if (!this.billNo) {
            this.$refs['customer'].focus()
        }
    },
    methods: {
        queryFormLeftOrRight(selfRef, nextOrPrevRef) {
            queryFormLeftOrRight(selfRef, nextOrPrevRef)
        },
        async getBalanceAmt() {
            this.$refs.queryFormRef.tableData = this.$refs.queryFormRef.pushItem()
            this.beforeTableData = []
            this.selection.amt = 0
            this.selection.length = 0
            this.queryitem.prePayAmt = 0
        },
        async getBtnPower() {
            this.isGetPower = false
            const { data: res } = await this.$http.post('/Account/dataSearchVue/selectFunctionButtonAuth.html', this.Qs.stringify({ menuID: 207 }))
            this.isGetPower = true
            res.result = JSON.parse(res.result)
            this.btnPower = JSON.parse(res.result.data)
            console.log(this.btnPower)
        },
        async getPower() {
            const { data: res } = await this.$http.post('/Account/dataSearchVue/selectColAndAuthByFuncCode.html', this.Qs.stringify({ funcCode: 201 }))
            this.isGetPower = true
            res.result = JSON.parse(res.result)
            this.power = {...this.power, ...JSON.parse(res.result.data)}
        },
        async getPromotion(row) {
            let { isHasPromotionData, value } = row
            if (isHasPromotionData) return
            const { data: res } = await this.$http.post('/Account/salConsignVue/selectPromotionItemDetail.html', this.Qs.stringify({ planID: value }))
            if (res.code != 'success') return
            const { planInfo, itemList } = JSON.parse(JSON.parse(res.result).data)
            this.$set(row, 'isHasPromotionData', true)
            this.$set(row, 'multiple', 1)
            this.$set(row, 'planInfo', planInfo)
            this.$set(row, 'itemList', itemList)
        },
        promotionInputChange(val, { value }) {
            this.$nextTick(() => {
                this.$refs[value].doShow()
            })
        },
        // 添加全部商品到单据
        addProductToOrder({ itemList, multiple }, isPromotion) {
            multiple = Number(multiple || 0)
            if (this.queryitem.customerID == '') return this.$message({
                showClose: true,
                message: '请先选择客户',
                type: 'warning'
            })
            if (this.queryitem.salOrderMeet == '') return this.$message({
                showClose: true,
                message: '请先选择订货会',
                type: 'warning'
            })
            const sal = this.$refs.queryFormRef
            let tableData = [...sal.tableData].reverse()
            let length = tableData.length
            this.$nextTick(() => {
                tableData.some((item, index) => {
                    if (item.itemID) {
                        itemList.map((row, $index) => {
                            let tempItem = {}
                            tempItem.salUnitQty = Number(toFixedRe((Number(row.salUnitQty) * multiple), 2))
                            tempItem.midUnitQty = Number(toFixedRe((Number(row.midUnitQty) * multiple), 2))
                            tempItem.invUnitQty = Number(toFixedRe((Number(row.invUnitQty) * multiple), 2))
                            tempItem.totalAmt = Number(toFixedRe((Number(sal.amt({ row: row })) * multiple), 2))
                            this.$set(sal.tableData, length - index + $index, { ...row, ...tempItem })
                        })
                        return true
                    }
                    if ((sal.tableData.length - 1) == index) {
                        itemList.map((row, $index) => {
                            let tempItem = {}
                            tempItem.salUnitQty = Number(toFixedRe((Number(row.salUnitQty) * multiple), 2))
                            tempItem.midUnitQty = Number(toFixedRe((Number(row.midUnitQty) * multiple), 2))
                            tempItem.invUnitQty = Number(toFixedRe((Number(row.invUnitQty) * multiple), 2))
                            tempItem.totalAmt = Number(toFixedRe((Number(sal.amt({ row: row })) * multiple), 2))
                            this.$set(sal.tableData, $index, { ...row, ...tempItem })
                        })
                        return true
                    }
                })
                let amt = 0
                this.$refs.queryFormRef.tableData.forEach(item => {
                    if (item.totalAmt) {
                        amt += item.totalAmt
                    }
                })
            })
        },
        getProductData(e) {
            this.itemParams = e
            if (this.$refs.queryFormRef) {
                let item = this.$refs.queryFormRef.itemName.request.params
                this.$refs.queryFormRef.itemName.request.params = { ...item, ...e }
            }
        },
        showCollapse() {
            this.isCollapse = !this.isCollapse
            this.$refs.queryFormRef.getHeight()
        },
        querySelect(tag, next) {
            if (tag == 'customer') {
                this.$refs.orderCascader.getBrandData()
            }
            this.$nextTick(() => {
                this.$refs[tag].$children[0].blur()
                this.$refs[next].focus()
            })
        },
        selectClick() {
            this.$nextTick(async () => {
                if (this.$refs.queryFormRef.sum.total) {
                    const confirmResult = await this.$confirm('您已录入商品，此操作将删除所以表格数据, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).catch(err => err)
                    if (confirmResult !== 'confirm') {
                        this.$refs['customer'].$children[0].blur()
                        this.$refs['salOrderMeet'].$children[0].blur()
                        return
                    } else {
                        this.$refs.queryFormRef.clearTable()
                    }
                }
            })
        },
        showDialog(obj) {

            this.dialogVisible = true
            this.dialogInfo.totalAmt = obj.totalAmt
            this.$refs.accountDialog.getSalPayBalanceAmt(obj.customerID)
            this.$refs.accountDialog.getCustomerPayMethod(obj.customerID)
            this.$refs.accountDialog.getSalPayBalanceByCustomerID(obj.customerID, obj.itemList.filter(item => item.itemID))
        },
        hideDialog() {
            this.dialogVisible = false
        },
        onSubmit(val) {
            console.log(val)
            let { queryForm } = val
            if (queryForm.cardAmt > 0 && !queryForm.account.selected.value) return this.$message.error('请选择支付方式')
            this.$refs.queryFormRef.onSubmit(val)
            // sal.onSubmit(val)
        },
        // 复制或编辑，根据billNo获取单据详情
        getEditTabledata() {
            this.$nextTick(async () => {
                let $table = this.$refs.queryFormRef
                $table.tableLoading = true
                const { data: res } = await this.$http.post('/Account/dataSearchVue/selectBillDetail.html', this.Qs.stringify({
                    billType: 'DHD',
                    billNo: this.billNo
                }))
                let { headInfo, itemList } = JSON.parse(JSON.parse(res.result).data)
                if (res.code != 'success') return this.$message.error(res.message)
                let setCustomer = () => {
                    let customer = this.queryForm.customer.selected = { value: headInfo.customerID, text: headInfo.customerName }
                    this.queryForm.customer.list = this.queryForm.customer.list.filter(item => item.value != customer.value)
                    this.queryForm.customer.list.unshift(customer)
                    // 如果是billNo有值时，不需要默认激活“客户”这个查询条件的下拉框
                    if(this.billNo) return
                    this.$refs.customer.focus()
                }
                if (this.queryForm.customer.list.length) {
                    setCustomer()
                } else {
                    const unwatch = this.$watch('queryForm.customer.list', (val) => {
                        this.$nextTick(() => {
                            unwatch()
                            setCustomer()
                        })
                    })
                }

                let salesman = this.queryForm.salesman.selected = { value: headInfo.salesmanID, text: headInfo.salesmanName }
                this.queryForm.salesman.list = this.queryForm.salesman.list.filter(item => item.value != salesman.value)
                this.queryForm.salesman.list.unshift(salesman)

                let salOrderMeet = this.queryForm.salOrderMeet.selected = { value: headInfo.salOrderMeetID, text: headInfo.salOrderMeetName }
                this.queryForm.salOrderMeet.list = this.queryForm.salOrderMeet.list.filter(item => item.value != salOrderMeet.value)
                this.queryForm.salOrderMeet.list.unshift(salOrderMeet)
                this.queryForm.remark.selected = headInfo.remark
                this.power.billNo = this.billNo
                this.power.tag = this.tag
                console.log(this.tag, 232323)
                const result = await $table.addProductToOrder(itemList)
                if (result) $table.tableLoading = false
            })
        },
    }
}
</script>
<style scoped lang="less">
#tab {

    .content {
        height: calc(100% - 100px - 2px);
    }

    .el-aside {
        /deep/.el-card__header {
            span {
                color: #333;
                font-size: 14px;
            }
        }
    }

    &>.el-main {
        padding: 0 0 0 12px;

        .tabs-card {
            height: calc(100% - 2px);
        }

        /deep/.el-tabs__content {
            padding: 0 12px;
            height: calc(100% - 40px - 1px);

            .el-tab-pane {
                height: calc(100% - 66px);
            }
        }

        ::v-deep .el-card {

            .el-card__body {
                height: calc(100% - 24px);
                padding: 12px;

                .query_form {
                    position: relative;
                    display: flex;

                    .query_form_item {
                        position: relative;
                        flex: 1;
                    }

                    .el-form-item__label {
                        position: absolute;
                        z-index: 2;
                        top: -12px;
                        margin-left: 10px;
                        padding: 0 6px;
                        background-color: #fff;
                        line-height: normal;
                        font-family: "Helvetica Neue";
                        font-size: 12px;
                        color: #000;
                    }

                    .el-form-item {
                        margin-bottom: 0;
                    }
                }
            }
        }

        .el-container {
            height: calc(100% - 33px - 2px);

            .el-aside {
                width: 300px;
                border-top: none;
                height: 100%;
            }

            .el-main {
                padding: 0;
                height: 100%;

                .query {
                    height: 100%;
                }
            }
        }
    }

    .isCollapse {
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        border: 1px #DCDFE6 solid;
        cursor: pointer;
        background-color: rgba(83, 168, 255, 0.1);
        color: #409EFF;
    }

    /deep/.box-card {
        height: calc(100% - 2px);

        .el-cascader-panel.is-bordered {
            border: none;
        }

        .el-card__header {
            padding: 8px 20px;
        }

        .el-card__body {
            padding: 0;
            height: calc(100% - 37px);
        }

        .el-card__body>div {
            height: 100%;
        }

        .el-cascader-panel {
            width: 100%;
            height: 100%;
            display: flex;
        }

        .el-cascader-menu {
            flex: 1;
            min-width: 0;
        }

        .el-cascader-menu__wrap {
            height: 100%;
            overflow-x: hidden;
        }

        .el-cascader-node {
            padding: 0 12px;
        }

        .el-cascader-node__label {
            width: 100%;
            height: 100%;
            padding: 0;
        }

        .cascader_text {
            width: 100%;
            display: inline-block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }

        .el-cascader-panel .el-icon-check:before {
            content: '';
        }

        .el-cascader-node__postfix {
            display: none;
        }

        .cascader_popper .el-row {
            margin-bottom: 10px;
        }

        .cascader_popper .el-col label {
            width: 60px;
            display: inline-block;
            text-align: right;
            margin-right: 6px;
        }

        .cascader_table {
            margin-top: 12px;
            height: 280px;
        }

        .badge {
            position: absolute;
            right: 6px;
        }
    }

    ::v-deep .el-dialog {
        height: 86vh;
        min-width: 1000px;

        .el-dialog__body {
            height: calc(100% - 54px);
            padding-top: 0;
            box-sizing: border-box;
            display: flex;
            flex-flow: column;

            .dialog-table {
                height: calc(100% - 48px);
            }

            .box-card-query {
                .el-card__body {
                    padding: 6px;
                }

                .el-form {
                    .el-form-item {
                        margin-bottom: 0;
                    }
                }
            }
        }
    }

    .border {
        border-top: 1px #E4E7ED solid;
    }

    .cell-p {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}
</style>